export const DETAIL_PANEL_WIDTH_CSS_VAR = '--detailPanelWidth';
